import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { useUserStore } from './authentication/user.store'
import PrimeVue from 'primevue/config'
import LaraGoalbook from './presets/lara-goalbook'
import App from './App.vue'
import router from './router/index.ts'
import { useVisibilityStore } from './visibility/visibility.store'
import { useRouterStore } from '@/router/router.store.ts'
import { useTrackingStore } from './tracking/tracking.store.ts'
import { useAirbrake } from './airbrake'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import Tooltip from 'primevue/tooltip'
import tooltip from './presets/lara-goalbook/tooltip'
import { analyticsPlugin } from '@/tracking/analytics/plugin.ts'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { setupHandleRequest } from '@/authentication/request_handler.ts'
import betaFeatureDirective from './router/beta-feature-directive.ts'
import iodRedirectDirective from './router/iod-redirect-directive.ts'
import { initSentry } from './sentry.js'

export const app = createApp(App)
app.use(createPinia())
initSentry(app)
const routerWithAirbrake = useAirbrake(router)
app.use(routerWithAirbrake)
app.use(PrimeVue, {
  unstyled: true,
  pt: {
    ...LaraGoalbook,
    directives: {
      tooltip: tooltip
    }
  }
})
app.use(ToastService)
app.use(ConfirmationService)
app.use(analyticsPlugin)
app.use(VueQueryPlugin)
app.directive('tooltip', Tooltip)
app.directive('beta-feature', betaFeatureDirective)
app.directive('iod-redirect', iodRedirectDirective)
app.config.globalProperties.$filters = {
  capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1)
  }
}

const userStore = useUserStore()
const visibilityStore = useVisibilityStore()
const routerStore = useRouterStore()
const trackingStore = useTrackingStore()

trackingStore.initTracking()
userStore.getUserInfo().then((data) => {
  if (userStore.isSuperAdmin) {
    visibilityStore.toggleEditorMode(true)
  }
  if (userStore.isTestUser) {
    visibilityStore.toggleBetaMode(true)
  }
  if (data && data.diagnostics) {
    // wrap this inside a try/catch so exceptions don't disrupt the flow of execution for the app
    try {
      document.getElementById('ci-build-info').innerHTML =
        `build ${data.diagnostics.build}, ${data.diagnostics.sha1}`
      console.info(data.diagnostics)
    } catch {
      // do nothing
    }
  }
})

setupHandleRequest(routerStore.forceReloginAndWait)

app.mount('#app')
window.__VUE_APP_MOUNTED__ = true
